export default class lightboxBehind {
	constructor(element) {
        element.classList.add('lightbox__behind--scale');
    }
}

